<script setup lang="ts">
import { VBtnToggle } from 'vuetify/components';
import Button from './Button.vue';
import type { ButtonSize, ButtonVariant } from './Button.vue';

interface ToggleButtonOption {
  title: string;
  value: string;
}

defineProps<{
  modelValue: string;
  options: ToggleButtonOption[];
  mandatory?: boolean;
  divided?: boolean;
  variant?: ButtonVariant;
  size?: ButtonSize;
}>();

defineEmits<(e: 'update:modelValue', value: string) => void>();
</script>

<template>
  <VBtnToggle
    :modelValue="modelValue"
    :mandatory="mandatory"
    :divided="divided"
    @update:modelValue="$emit('update:modelValue', $event)"
  >
    <Button
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :label="option.title"
      :variant="variant ?? 'secondary'"
      :size="size !== undefined ? size : undefined"
      :class="{ selected: modelValue === option.value }"
    />
  </VBtnToggle>
</template>

<!-- selected button styles -->
<style scoped lang="scss">
.v-btn-group--density-default.v-btn-group {
  height: auto;
}

.selected.primary-v-btn-overwrite {
  background: rgb(var(--v-theme-secondary-darken-2));
  color: white !important;
  outline: 2px solid rgb(var(--v-theme-secondary-darken-3)) !important;
  outline-offset: -2px;
}
.selected.secondary-v-btn-overwrite {
  background: rgb(var(--v-theme-secondary-darken-3), 0.08);
  color: rgb(var(--v-theme-secondary-darken-3)) !important;
  outline: 2px solid rgb(var(--v-theme-secondary-darken-3)) !important;
  outline-offset: -2px;
}
.selected.special-v-btn-overwrite {
  background: rgb(var(--v-theme-error-darken-1));
  color: white !important;
  outline: 2px solid rgb(var(--v-theme-error-darken-1)) !important;
  outline-offset: -2px;
}
.selected.text-v-btn-overwrite {
  background: rgb(var(--v-theme-secondary-darken-3), 0.15);
  color: rgb(var(--v-theme-secondary-darken-3)) !important;
  outline: 2px solid rgb(var(--v-theme-secondary-darken-3)) !important;
  outline-offset: -2px;
}
.selected.ghost-v-btn-overwrite {
  background: rgb(var(--v-theme-secondary-darken-3), 0.08);
  color: rgb(var(--v-theme-secondary-darken-3)) !important;
  outline: 2px solid rgb(var(--v-theme-secondary-darken-3)) !important;
  outline-offset: -2px;
}
</style>
